import OInputField from "components/reusable/OInputField";
import AuthContext from "context/AuthContext";
import useToastContext from "hooks/useToastContext";
import { useContext, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { apiGet, apiPost } from "utils/apiFetch";
import apiPath from "utils/pathObj";
import AgentOtpScreen from "./auth/AgentOtpScreen";

import { faChevronDown, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";

const CashIn = ({ setShowCashInModal }) => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange", shouldFocusError: true, defaultValues: {} });
  const notification = useToastContext();
  const [cashInLoading, setCashInLoading] = useState(false);
  const [cashPreview, setCashPreview] = useState(false);
  const [cashPreviewData, setCashPreviewData] = useState({});
  const [radioPaymentMode, setRadioPaymentMode] = useState("wallet");
  const [cashInData, setCashInData] = useState(false);
  const [isOTP, setIsOTP] = useState(false);
  const [otp, setOtp] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState({});
  const [otpError, setOtpError] = useState("");

  const [selectedWallet, setSelectedWallet] = useState(null);
  const [availableWallets, setAvailableWallets] = useState([]);
  const [loadingWallets, setLoadingWallets] = useState(false);
  const abortController = new AbortController();

  const { user } = useContext(AuthContext);
  const handleSubmitForm = async (data) => {
    try {
      console.log("first");
      if (user?.role === "agent" && radioPaymentMode === "cash") {
        if (!otp) {
          setOtpError(t("PLEASE_ENTER_OTP"));
          return;
        } else if (otp.length < 4) {
          setOtpError(t("PLEASE_ENTER_OTP"));
          return;
        } else {
          setOtpError("");
        }
      }

      setCashInLoading(true);
      const sendData = {
        username: data?.username,
        walletId: selectedWallet._id,
        amount: Number(data.amount),
        cashInType: radioPaymentMode,
      };
      const res = await apiPost(apiPath.AddCashIn, { ...sendData, otp });
      if (res.data.success === true) {
        setCashInData(true);
        notification.success(res.data.message);
      } else {
        setShowCashInModal(false);
        notification.error(res.data.message);
      }
    } catch (err) {
      console.log("err:", err);
    } finally {
      setCashInLoading(false);
    }
  };

  const handleSubmitPreview = async (data) => {
    try {
      setCashInLoading(true);
      const sendData = {
        username: data?.username,
        walletId: selectedWallet._id,
        cashInType: radioPaymentMode,
        amount: Number(data.amount),
      };
      const res = await apiPost(apiPath.cashInPreview, sendData);
      if (res?.data?.success === true) {
        setCashPreviewData(res?.data?.results);
        setCashPreview(true);
        if (user?.role === "agent" && radioPaymentMode === "cash") {
          setPaymentDetails(sendData);
          setIsOTP(true);
        }
        notification.success(res.data.message);
      } else {
        notification.error(res.data.message);
      }
    } catch (err) {
      console.log("err:", err);
    } finally {
      setCashInLoading(false);
    }
  };

  const handleAmount = (e) => {
    var value = e.target.value;
    const pattern = /^\d{0,5}(\.\d{0,2})?$/;
    if (e.target.value === "") {
      e.target.value = e.target.value.slice(e.target.value?.length - 1, -1);
    }
    const isValid = pattern.test(value);
    if (!isValid) {
      value = value.slice(0, -1);
    }
    setValue("amount", value);
  };

  const fetchUserWallets = async (username) => {
    try {
      abortController.abort();
      setLoadingWallets(true);
      const res = await apiGet(apiPath.getUserWallets + "?username=" + username, abortController.signal);
      setLoadingWallets(false);
      if (res.data.success) {
        setAvailableWallets(res.data.results);
        if (res.data.results.length === 1) {
          setSelectedWallet(res.data.results[0]);
        }
      } else {
        setSelectedWallet(null);
        setAvailableWallets([]);
      }
    } catch (err) {
      setLoadingWallets(false);
      setSelectedWallet(null);
      setAvailableWallets([]);
      console.log("err:", err);
    }
  };

  var pressedKeys = [];

  return (
    <>
      <div id="add-agent" className="fixed  pt-16 z-40 h-screen px-6 pb-4 overflow-y-auto bg-white sm:w-96 w-80 right-0 top-0 " aria-labelledby="drawer-label">
        <div>
          <button
            onClick={() => setShowCashInModal(false)}
            title="Close"
            type="button"
            data-drawer-hide="drawer-example"
            aria-controls="drawer-example"
            className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
          >
            <img src="./images/close-circle.png" alt="close" />

            <span className="sr-only">{t("CLOSE_MENU")}</span>
          </button>
        </div>
        <h3 className="font-medium text-[18px] mb-4">{t("CASH_IN_TOP_UP_CUSTOMER")}</h3>
        <form>
          <div className="flex my-5 gap-4">
            <div className="relative w-full ">
              <OInputField
                name="username"
                inputLabel={
                  <>
                    {t("O_USERNAME")}
                    <span className="text-red-500">*</span>
                  </>
                }
                errors={errors}
                type="text"
                onKeyDown={(e) => {
                  if ([" "].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  fetchUserWallets(e.target.value);
                }}
                register={register("username", {
                  required: t("PLEASE_ENTER_USERNAME"),
                })}
              />
            </div>
          </div>

          <Menu as="div" className="relative inline-block w-full flex justify-center">
            <MenuButton className="w-full rounded-md bg-gray-200 px-3 py-2 inset-ring-1 inset-ring-white/5 hover:bg-gray-300">
              {selectedWallet ? (
                <div className="flex flex-col text-left">
                  <h6 className="font-bold text-sm">
                    {selectedWallet.wallet_description} ({selectedWallet.wallet_number})
                  </h6>
                  <span className="text-sm">
                    {selectedWallet.wallet_currency} {selectedWallet.wallet_amount}
                  </span>
                </div>
              ) : (
                <>{t("SELECT_WALLET")}</>
              )}
              {loadingWallets ? <FontAwesomeIcon icon={faSpinner} className="bg-white-900" /> : <FontAwesomeIcon icon={faChevronDown} className="bg-white-900" />}
            </MenuButton>

            <MenuItems
              transition
              style={{ zIndex: 1000 }}
              className="absolute z-10 mt-2 w-56 origin-top-right divide-y divide-white/10 rounded-md bg-gray-800 outline-1 -outline-offset-1 outline-white/10 transition data-closed:scale-95 data-closed:transform data-closed:opacity-0 data-enter:duration-100 data-enter:ease-out data-leave:duration-75 data-leave:ease-in"
            >
              {availableWallets?.length === 0 && <div className="px-4 py-3 text-sm text-gray-300 w-full">{t("NO_WALLET_AVAILABLE")}</div>}

              {availableWallets?.map((wallet) => (
                <div className="py-1 w-full" key={wallet._id}>
                  <MenuItem key={wallet._id}>
                    <span className="block px-4 py-2 text-sm text-gray-300 data-focus:bg-white/5 data-focus:text-white data-focus:outline-hidden" onClick={() => setSelectedWallet(wallet)}>
                      {wallet.wallet_description} - {wallet.wallet_currency} {wallet.wallet_amount}
                    </span>
                  </MenuItem>
                </div>
              ))}
            </MenuItems>
          </Menu>

          <div className="relative  my-5">
            <OInputField
              name="amount"
              errors={errors}
              inputLabel={
                <>
                  {t("CASH_IN_COLLECTED_AMOUNT")}
                  <span className="text-red-500">*</span>
                </>
              }
              type="number"
              register={register("amount", {
                required: t("PLEASE_ENTER_COOLECTED_AMOUNT"),
                onChange: (e) => handleAmount(e),
                validate: (value) => {
                  return value !== "0" ? true : t("VALUE_CAN_NOT_BE_LESS_THAN_0.01");
                },
              })}
              onKeyDown={(e) => {
                pressedKeys.push(e.key);
                var lastKey = pressedKeys[pressedKeys.length - 2];
                if (lastKey === ".") {
                  if (["-", ".", "+", "e"].includes(e.key)) {
                    e.preventDefault();
                  }
                } else if (["-", "+", "e"].includes(e.key)) {
                  e.preventDefault();
                }
              }}
            />
            {user?.role === "agent" && (
              <div className="relative  my-5">
                <div>
                  <input defaultChecked type="radio" className="form-check-input" value="wallet" name="radioValueWallet" onChange={(e) => setRadioPaymentMode(e.target.value)} />
                  <label className="form-check-label mr-5"> {t("WALLET")}</label>
                  <input type="radio" value="cash" className="form-check-input" name="radioValueWallet" onChange={(e) => setRadioPaymentMode(e.target.value)} />
                  <label className="form-check-label"> {t("CASH")}</label>
                </div>
              </div>
            )}
          </div>
          <div>
            <div className="bg-amber-50 p-2 rounded-lg items-center mb-4">
              <h6 className="text-amber-300 font-medium">{t("CASH_IN_NOTE")} :</h6>
              <h6 className="text-Black font-medium text-[16px]">{t("CASH_IN_SERVICE_DEDUCTION")}</h6>
            </div>
          </div>
          <button
            class="bg-LightBlue hover:bg-DarkBlue cursor-pointer   text-white  font-medium  w-full active:bg-slate-100 text-sm px-8 py-4 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150 undefined"
            type="submit"
            disabled={cashInLoading || selectedWallet === null}
            onClick={handleSubmit(handleSubmitPreview)}
          >
            {cashInLoading ? "Loading..." : <>{t("CASH_IN_TRANSFER")}</>}
          </button>
          {cashPreview ? (
            <>
              <div id="add-agent" className="fixed  pt-16 z-40 h-screen px-6 pb-4 overflow-y-auto bg-white sm:w-96 w-80 right-0 top-0 " aria-labelledby="drawer-label">
                <div>
                  <button
                    onClick={() => setShowCashInModal(false)}
                    title="Close"
                    type="button"
                    data-drawer-hide="drawer-example"
                    aria-controls="drawer-example"
                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  >
                    <img src="./images/close-circle.png" alt="close" />

                    <span className="sr-only">{t("CLOSE_MENU")}</span>
                  </button>
                </div>
                <div className=" items-center w-full justify-center mb-4">
                  <div className="relative text-center mb-5">
                    <label>{t("O_RECORDS")}</label>
                    <img src={cashPreviewData.image} alt="pfp" className="mx-auto" style={{ height: "5rem" }} />
                    <h3 className="font-medium text-[18px]">{`${cashPreviewData.firstName} ${cashPreviewData.lastName} (+${cashPreviewData.countryCode}${cashPreviewData.mobile})`}</h3>
                  </div>

                  <div className="hr w-100  mb-3" style={{ borderBottom: "1px solid black" }}></div>

                  <div className="relative text-center ">
                    <h3 className="font-medium text-[18px] mb-4">
                      {t("O_CUSTOMER_WILL_GET")} {cashPreviewData.amountToBeReceived} {t("CASH_IN_WALLET_TRANSFER")} {cashPreviewData.amount} {t("O_LEK")}
                    </h3>
                  </div>
                </div>
                {isOTP && <AgentOtpScreen setIsOTP={setIsOTP} otp={otp} setOtp={setOtp} paymentDetails={paymentDetails} otpError={otpError} />}
                <div className="flex justify-between items-center">
                  <button
                    class="bg-LightBlue hover:bg-DarkBlue cursor-pointer text-white  font-medium active:bg-slate-100 text-sm px-8 py-4 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150 undefined"
                    type="button"
                    onClick={() => setShowCashInModal(false)}
                  >
                    {t("CASH_IN_CANCEL")}
                  </button>
                  <button
                    class="bg-LightBlue hover:bg-DarkBlue cursor-pointer text-white  font-medium active:bg-slate-100 text-sm px-8 py-4 rounded-lg shadow hover:shadow-lg outline-none focus:outline-none  ease-linear transition-all duration-150 undefined"
                    disabled={cashInLoading}
                    type="button"
                    onClick={handleSubmit(handleSubmitForm)}
                  >
                    {cashInLoading ? "Loading..." : <>{t("CASH_IN_OK")}</>}
                  </button>

                  {cashInData ? (
                    <div id="add-agent" className="fixed  pt-16 z-40 h-screen px-6 pb-4 overflow-y-auto bg-white sm:w-96 w-80 right-0 top-0 " aria-labelledby="drawer-label">
                      <div>
                        <button
                          onClick={() => setShowCashInModal(false)}
                          title="Close"
                          type="button"
                          data-drawer-hide="drawer-example"
                          aria-controls="drawer-example"
                          className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 absolute top-2.5 right-2.5 inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        >
                          <img src="./images/close-circle.png" alt="close" />

                          <span className="sr-only">{t("CLOSE_MENU")}</span>
                        </button>
                      </div>
                      <div className="flex items-center w-full justify-center mb-4">
                        <div className="relative text-center ">
                          <div className="w-32 h-30 relative mx-auto">
                            <img src="images/check.png" alt="No_image" />
                          </div>
                          <h3 className="font-medium text-[18px] mb-4">
                            {t("CASH_IN_THE_AMOUNT_TRANSFERRED")} {cashPreviewData.mobile}
                          </h3>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </>
          ) : (
            ""
          )}
        </form>
      </div>

      <div class="bg-gray-900  bg-opacity-50 dark:bg-opacity-80 fixed inset-0 z-30 overlay" />
    </>
  );
};

export default CashIn;
